import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const statusPillVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      status: {
        matched: 'border-status-matched-border bg-status-matched-bg text-status-matched',
        unmatched: 'border-status-unmatched-border bg-status-unmatched-bg text-status-unmatched',
        ambiguous: 'border-status-ambiguous-border bg-status-ambiguous-bg text-status-ambiguous',
        omitted: 'border-status-omitted-border bg-status-omitted-bg text-status-omitted',
      },
    },
    defaultVariants: {
      status: 'omitted',
    },
  },
);

export interface StatusPillProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusPillVariants> {
  /** Hide the leading status dot. */
  hideDot?: boolean;
}

const StatusPill = React.forwardRef<HTMLSpanElement, StatusPillProps>(
  ({ className, status, hideDot = false, children, ...props }, ref) => (
    <span ref={ref} className={cn(statusPillVariants({ status, className }))} {...props}>
      {!hideDot && <span aria-hidden className="size-1.5 rounded-full bg-current" />}
      {children}
    </span>
  ),
);
StatusPill.displayName = 'StatusPill';

export { StatusPill, statusPillVariants };
